import {
    createStyles,
    Typography,
    WithStyles,
    withStyles,
} from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";

import { baseColors, RelodeTheme } from "../";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            alignContent: "center",
            color: baseColors.purple,
            textAlign: "center",
        },
        padding: {
            padding: theme.spacing(4),
        },
        errorText: {
            color: "red",
        },
    });

interface NoResultsTextProps extends WithStyles<typeof styles> {
    children?: React.ReactNode;
    className?: string;
    padding?: boolean;
    error?: boolean;
}

export const NoResultsText = withStyles(styles, { name: "NoResultsText" })((props: NoResultsTextProps) => {
    const { children, classes, className: classNameProp, padding = true, error = false, ...other } = props;

    const rootClasses = classnames(
        classes.root,
        {
            [classes.padding]: padding,
            [classes.errorText]: error,
        },
        classNameProp
    );

    return (
        <Typography variant="h2" className={rootClasses} {...other}>
            {children}
        </Typography>
    );
});
